import { computed } from "mobx";
import type NotificationService from "../services/notificationService";
import { NotificationType } from "../services/notificationService";
import AlertViewModel, { AlertVariant } from "./alertViewModel";

export default class AlertsViewModel {
  constructor(private notificationService: NotificationService) {}

  @computed
  get children() {
    const notificationTypeToAlertVariant = (type: NotificationType) => {
      return {
        [NotificationType.ERROR]: AlertVariant.DANGER,
        [NotificationType.INFO]: AlertVariant.INFO,
        [NotificationType.SUCCESS]: AlertVariant.SUCCESS,
        [NotificationType.WARNING]: AlertVariant.WARNING,
      }[type];
    };

    const items: AlertViewModel[] = [];

    this.notificationService.notifications.forEach((notification, key) => {
      let onClose;

      if (!notification.permanent || notification.closable) {
        onClose = () => {
          this.notificationService.remove(key);
        };
      }
      items.push(new AlertViewModel(notification, notificationTypeToAlertVariant(notification.type), onClose));
    });

    return items;
  }
}
